export const getBSInfantCerealPackage = newProduct => {
  let newBSInfantCerealPackage = {
    UPC: newProduct.UPC,
    GrainType: newProduct.GrainType,
    Iron: newProduct.Iron,
    IronCertification: newProduct.IronCertification,
    NoAdditionalIngredients: newProduct.NoAdditionalIngredients,
    Size: newProduct.Size,
    Organic: newProduct.Organic,
  }
  if (newProduct.GrainType === 'Other') {
    newBSInfantCerealPackage.OtherGrainType = newProduct.OtherGrainType
  }
  return newBSInfantCerealPackage
}
export const updateBSInfantCerealPackage = newProduct => {
  let newBSInfantCerealPackage = {
    UPC: newProduct.UPC,
    GrainType: newProduct.GrainType,
    Iron: newProduct.Iron,
    IronCertification: newProduct.IronCertification,
    NoAdditionalIngredients: newProduct.NoAdditionalIngredients,
    Size: newProduct.Size,
    Organic: newProduct.Organic,
  }
  if (newProduct.GrainType === 'Other') {
    newBSInfantCerealPackage.OtherGrainType = newProduct.OtherGrainType
  }
  return newBSInfantCerealPackage
}
